import styled from 'styled-components';
import { colors, ApSimpleSearch } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  display: flex;
  min-width: 320px;
  flex-direction: column;
  height: 100%;
  padding-top: 16px;
`;

export const HeaderLabel = styled.div`
  display: flex;
  font-size: 11px;
  line-height: 13px;
  color: ${colors.grey5};
  padding-top: 16px;
  padding-left: 4px;
`;

export const HeaderCenterLabel = styled(HeaderLabel)`
  justify-content: center;
  text-align: center;
`;

export const HeaderRightLabel = styled(HeaderLabel)`
  justify-content: flex-end;
  padding-right: 8px;
`;

export const SearchWrapper = styled.div`
  width: 203px;
  margin-right: 32px;
`;

export const NoDataWrapper = styled.div`
  font-size: 16px;
  color: ${colors.grey6};
  text-align: center;
  padding: 16px 0;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

export const StyledSearch = styled(ApSimpleSearch)`
  border-radius: 0;
  border-color: ${colors.grey4};
  height: 40px;

  &:focus:enabled,
  & ~ button:focus:enabled {
    box-shadow: none;
  }

  &:focus,
  &:hover {
    border-color: ${colors.green2};
  }

  &:active {
    border-color: ${colors.green3};
  }

  &:disabled {
    pointer-events: none;
    color: ${colors.grey5};
    border-color: ${colors.grey2};
  }
`;
